import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHide = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} fill='none' {...props}>
    <rect width={24} height={24} fill='#E0E3EB' rx={6} />
    <path
      stroke='#323E54'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='m13.687 10.313-3.374 3.374a2.384 2.384 0 1 1 3.373-3.373'
    />
    <path
      stroke='#323E54'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M15.88 7.846c-1.167-.88-2.5-1.36-3.88-1.36-2.353 0-4.547 1.387-6.073 3.787-.6.94-.6 2.52 0 3.46a9.6 9.6 0 0 0 1.806 2.113M9.613 17.02c.76.32 1.567.494 2.387.494 2.353 0 4.547-1.387 6.073-3.787.6-.94.6-2.52 0-3.46-.22-.347-.46-.673-.706-.98'
    />
    <path
      stroke='#323E54'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M14.34 12.467a2.38 2.38 0 0 1-1.88 1.88M10.313 13.688l-4.98 4.98M18.667 5.334l-4.98 4.98'
    />
  </svg>
);
export default SvgHide;
